import { useNavigate } from 'react-router-dom';
import { useSite } from '../context/SiteContext';
import { IconMapPin, IconClock } from './Icons';
import styles from './TripCard.module.css';

export default function TripCard({ trip, onClick }) {
  const navigate = useNavigate();
  const { data } = useSite();
  const catObj = (data.categories || []).find(c => c.id === trip.category);
  const cat = catObj
    ? { bg: catObj.bg, color: catObj.color }
    : { bg: '#e6f4ea', color: '#2d7a3e' };
  const mainImage = (trip.images && trip.images.find(i => i.isMain))?.url
    || trip.images?.[0]?.url
    || trip.image
    || '';

  const handleClick = () => {
    if (onClick) { onClick(); return; }
    navigate(`/trips/${trip.slug}`);
  };

  const handleReadMore = (e) => {
    e.stopPropagation();
    navigate(`/trips/${trip.slug}`);
  };

  return (
    <div className={styles.card} onClick={handleClick}>
      <div className={styles.imgWrap}>
        <img src={mainImage} alt={trip.title} className={styles.img} loading="lazy" />
        <div className={styles.imgOverlay} />
        <div className={styles.catBadge} style={{ background: cat.bg, color: cat.color }}>
          {trip.category}
        </div>
        {trip.images && trip.images.length > 1 && (
          <div className={styles.photoCount}>📷 {trip.images.length}</div>
        )}
      </div>
      <div className={styles.body}>
        <h3 className={styles.title}>{trip.title}</h3>
        <div className={styles.meta}>
          <span className={styles.metaItem}><IconMapPin /> {trip.location}</span>
          <span className={styles.metaItem}><IconClock /> {trip.time}</span>
          <span className={styles.metaItem}>📏 {trip.distance}</span>
          <span className={styles.metaItem}>📅 {trip.date}</span>
        </div>
        <div className={styles.descWrap}>
          <p className={styles.desc}>{trip.description}</p>
          <button className={styles.readMoreBtn} onClick={handleReadMore}>
            Read more →
          </button>
        </div>
        <div className={styles.footer}>
          <span className={styles.price}>{trip.fees}</span>
          <span className={styles.level}>{trip.level}</span>
        </div>
      </div>
    </div>
  );
}
